import modalUtils from './modalUtils.js';


class Modal {

  constructor() {
    this.modalUtils = modalUtils


    this.prepareModals();
    this.prepareTriggers();
  }

  // Готовит к работе модальные окна, присутствующие на странице.
  // Необходима установка следующих атрибутов на модальном окне:
  // - data-auto-init
  prepareModals() {
    const modals = document.querySelectorAll('.modal[data-auto-init]');
    modals.forEach(modal => this.modalUtils.prepareModal(modal))
  }


  // Привязывает модальные окна к вызывающим элементам.
  // Необходима установка следующих атрибутов на вызывающем элементе:
  // - data-modal="modal" 
  // - data-target, должен содержать селектор (идентификатор) окна.
  prepareTriggers() {
    const triggers = document.querySelectorAll('[data-modal="modal"][data-target]');
    triggers.forEach(trigger => this.modalUtils.prepareTrigger(trigger))
  }


}

export default Modal;